import defaultSettings from '@/settings'
const {title,logo} = defaultSettings
console.log(defaultSettings)
const state={
    logo,
    title,
}
const mutations = {
    CHANGE_CONFIG: (state, { key, value }) => {
      // eslint-disable-next-line no-prototype-builtins
      if (state.hasOwnProperty(key)) {
        state[key] = value
      }
    }
  }

const actions = {
    changeConfig({ commit }, data) {
      commit('CHANGE_CONFIG', data)
    }
}
export default {
  namespaced: true,
    state,
    mutations,
    actions
  }
